import React, {useState} from 'react';
import styles from './LoginDialog.module.css';
import {Alert, Button, LinearProgress, TextField, Typography} from "@mui/material";
import ServerManager from "../../API/ServerManager";
import {user} from "../../modules/User";
import {getCurrentWorkDayStamp, setLastLoginWorkDayStamp} from "../../utils/LoginUtil";
import ArtistSuggestionsStatusService from "../../API/ArtistSuggestionsStatusService";

const LoginDialog = ({setIsLoggedIn}) => {

    const [login, setLogin] = useState("")
    const [password, setPassword] = useState("")
    const [errorMsg, setErrorMsg] = useState("")
    const [requestInProgress, setRequestInProgress] = useState(false)

    async function tryLogin() {

        setErrorMsg("");
        setRequestInProgress(true);

        let response = null;
        try {
            response = await ServerManager.login(login, password);
        }
        catch (error) {
            setErrorMsg("Не удалось выполнить вход!");
            return;
        }
        finally {
            setRequestInProgress(false);
        }

        // success //

        setLastLoginWorkDayStamp(getCurrentWorkDayStamp());
        user.id = response.id;
        user.email = response.email;
        user.name = response.name;
        user.addedEventCount = response.addedEventCount;

        setIsLoggedIn(true);

        ArtistSuggestionsStatusService.forceUpdate();
    }

    return (
        <div className={styles.main}>
            <div className={styles.rowItem}>
                <Typography variant="h4">
                    Вход
                </Typography>
            </div>
            <div className={styles.rowItem}>
                <TextField
                    type="text"
                    label="Логин"
                    sx={{ width: "100%" }}
                    onChange={(e) => setLogin(e.target.value)}
                    disabled={requestInProgress}
                />
            </div>
            <div className={styles.rowItem}>
                <TextField
                    type="password"
                    label="Пароль"
                    sx={{ width: "100%" }}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={requestInProgress}
                />
            </div>
            <div className={styles.rowItem}>
                <Button variant="contained" disabled={requestInProgress} onClick={() => { tryLogin() }}>Войти</Button>
                <Button variant="contained" disabled style={{width:"200px"}} title="fff">Зарегистрироваться</Button>
            </div>
            {requestInProgress && <LinearProgress />}
            {errorMsg && <Alert severity="error" onClose={() => {setErrorMsg("")}}>{errorMsg}</Alert>}
        </div>
    );
};

export default LoginDialog;